import { type FC, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { TextField } from '@/components/ui/text-field'
import { useToast } from '@/components/ui/toast'
import { handleError } from '@/utils/error'

import { useCreateFanList } from '../query/create-fan-list'

interface Props {
  isOpen: boolean
  onClose: () => void
  onCreate: (processId: string, listName: string) => void
  linkName: string
  linkId: number
}

const FIELD_ID = 'list-name'

export const CreateFanListDialog: FC<Props> = ({
  isOpen,
  onClose,
  onCreate,
  linkName,
  linkId,
}) => {
  const [listName, setListName] = useState('')
  const createFanListMutation = useCreateFanList()
  const toast = useToast()

  const handleClose = () => {
    setListName('')
    onClose()
  }

  const handleCreate = () => {
    createFanListMutation
      .mutateAsync({ listName, linkId })
      .then(({ listId }) => {
        onCreate(String(listId), listName)
        handleClose()
      })
      .catch((error) => {
        handleError(error, 'Failed to create fan list')
      })
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setListName(event.target.value)
  }

  return (
    <Dialog
      show={isOpen}
      onClose={handleClose}
    >
      <Dialog.Header>
        <Dialog.Title>Create Fan List</Dialog.Title>
        <Dialog.Description className="text-center">
          Creates a list on OnlyFans from the link &quot;{linkName}&quot; that
          will include all the fans that came through the link
        </Dialog.Description>
      </Dialog.Header>
      <div className="mt-6">
        <label
          htmlFor={FIELD_ID}
          className="text-sm font-medium text-text-default"
        >
          List Name
        </label>
        <TextField
          id={FIELD_ID}
          value={listName}
          onChange={handleChange}
          placeholder={linkName}
        />
      </div>
      <Dialog.ClosableFooter onClose={handleClose}>
        <Button
          onClick={handleCreate}
          isLoading={createFanListMutation.isLoading}
          disabled={!listName}
        >
          Create
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
